<template>
  <div>
    <div class="content">
      <div class="title">添加教育经历</div>
      <div class="cont">
        <div class="box">
          <div class="name">学校名称</div>
          <div class="inpBox">
            <input
              type="text"
              v-model="info.school"
              placeholder="请填写学校名称"
            />
          </div>
        </div>
        <div class="box">
          <div class="name">学历</div>
          <a-dropdown>
            <div class="selectBox">
              <div class="contBox">
                <div
                  class="text"
                  :class="educationTxt == '请选择' ? '' : 'hei'"
                >
                  {{ educationTxt }}
                </div>
              </div>
              <div class="iconfont icon-barrage barrage dis-cent"></div>
            </div>
            <a-menu
              slot="overlay"
              @click="hyClick"
              :selectedKeys="[typeData['学历']]"
            >
              <a-menu-item
                :key="'学历_' + item.id + '_' + item.c_name"
                v-for="item in education"
                >{{ item.c_name }}</a-menu-item
              >
            </a-menu>
          </a-dropdown>
        </div>
        <div class="box">
          <div class="name">专业</div>
          <div class="inpBox">
            <input
              type="text"
              v-model="info.speciality"
              mode="month"
              placeholder="请填写专业"
            />
          </div>
        </div>
        <div class="quanBox">
          <div class="name">在校时间</div>
          <div class="xuanCont">
            <div class="xuanBox">
              <a-month-picker
                v-model="info.start_time"
                :disabledDate="stardisabledDate"
                placeholder="开始时间"
                @change="stronChange"
              />
            </div>
            <div class="jian">-</div>
            <div class="xuanBox">
              <a-month-picker
                v-model="info.end_time"
                :disabledDate="stardisabledDate"
                placeholder="结束时间"
                @change="endonChange"
              />
            </div>
          </div>
        </div>
        <div class="quanBox" style="width: 100%">
          <div class="name">在校经历</div>
          <div class="areaBox">
            <textarea
              v-model="info.content"
              placeholder="请输入在校经历"
            ></textarea>
          </div>
        </div>
      </div>
      <div class="tcBom">
        <div class="qbtn dis-cent" @click="qxClick">取消</div>
        <div class="btn dis-cent" @click="qrClick">确定</div>
      </div>
    </div>
    <XuanzeHy v-if="qwShow" @show="qwShowJs" :qwData="qwData" />
    <XuanzeZw v-if="zwShow" @show="zwShowJs" :zwData="zwData" />
  </div>
</template>

<script>
import {
  Select,
  Menu,
  Form,
  Input,
  Dropdown,
  Upload,
  Icon,
  DatePicker,
  LocaleProvider,
} from "ant-design-vue";
import XuanzeHy from "../component/xuanzeHy.vue";
import XuanzeZw from "../component/xuanzeZw.vue";
import zhCN from "ant-design-vue/lib/locale-provider/zh_CN"; // 引入中文语言包
export default {
  components: {
    "a-select": Select,
    "a-select-option": Select.Option,
    "a-menu": Menu,
    "a-menu-item": Menu.Item,
    "a-sub-menu": Menu.SubMenu,
    "a-form": Form,
    "a-form-item": Form.Item,
    "a-input": Input,
    "a-dropdown": Dropdown,
    "a-textarea": Input.TextArea,
    "a-upload": Upload,
    "a-icon": Icon,
    "a-range-picker": DatePicker.RangePicker,
    "a-month-picker": DatePicker.MonthPicker,
    "locale-provider": LocaleProvider,
    XuanzeHy,
    XuanzeZw,
  },
  name: "",
  props: {
    info: { type: Object, default: {} },
  },
  data() {
    return {
      zhCN, // 使用中文语言包
      size: "default",
      qwShow: false,
      qwData: [],
      zwShow: false,
      zwData: [],
      addTxt: "请选择",
      qMoneyOn: null,
      qValue: undefined,
      qMoney: [],
      hValue: undefined,
      hMoney: [],
      yValue: undefined,
      yMoney: [],
      startMonth: null,
      endMonth: null,
      educationTxt: "请选择",
      educationId: "",
      content: "",
      typeData: {
        学历: "",
      },
    };
  },
  created() {
    let category_gets = window.localStorage.getItem("category_gets");
    if (category_gets) {
      this.category_gets = JSON.parse(category_gets);
      this.typeHcGet(this.category_gets);
    } else {
      this.typeGet();
    }
    if (this.info.education) {
      this.educationTxt = this.info.education_cn
      this.educationId = this.info.education
    }
  },
  methods: {
    stronChange(e) {
      this.info.start_time = this.$moment(e._d).format("YYYY-MM");
    },
    endonChange(e) {
      this.info.end_time = this.$moment(e._d).format("YYYY-MM");
    },
    typeGet() {
      this.$get("/common/category_gets", {
        pageNo: -1,
      }).then((res) => {
        window.localStorage.setItem("category_gets", JSON.stringify(res.data));
        this.typeHcGet(res.data);
      });
    },
    typeHcGet(data) {
      // 所属行业
      let education = [];
      for (let i = 0; i < data.length; i++) {
        const e = data[i];
        e.select = false;
        if (e.c_alias == "QS_education") {
          education.push(e);
        }
      }
      this.education = education;
    },
    hyClick(e) {
      let key = e.key.split("_");
      let data = {
        type: key[0],
        id: key[1],
        name: key[2],
      };
      this.typeData[key[0]] = e.key;
      if (key[0] == "学历") {
        this.educationTxt = data.name;
        this.educationId = data.id;
      }
    },
    stardisabledDate(current) {
      const today = new Date();
      return (
        current &&
        current.year() === today.getFullYear() &&
        current.month() > today.getMonth()
      );
    },
    onChange(e) {
      console.log(e);
    },
    ddClick(e) {
      this.addTxt = e.key;
    },
    // 行业选择
    qwShowJs(data) {
      this.qwShow = false;
      this.qwData = data.data;
    },
    qwClick() {
      this.qwShow = true;
    },
    qwDelClick(i) {
      this.qwData.splice(i, 1);
    },
    // 职业选择
    zwShowJs(data) {
      this.zwShow = false;
      this.zwData = data.data;
    },
    zwClick() {
      this.zwShow = true;
    },
    zwDelClick(i) {
      this.zwData.splice(i, 1);
    },
    qxClick() {
      this.$emit("show");
    },
    qrClick() {
      let data = {
        ...this.info,
        education: Number(this.educationId),
        education_cn: this.educationTxt,
      };
      if (!data.school) {
        this.$message.error("请输入学校名称");
        return;
      }
      if (!data.education) {
        this.$message.error("请选择学历");
        return;
      }
      if (!data.speciality) {
        this.$message.error("请填写专业");
        return;
      }
      if (!data.start_time || !data.end_time) {
        this.$message.error("请选择在校时间");
        return;
      }
      if (!data.content) {
        this.$message.error("请输入在校经历");
        return;
      }
      data = JSON.stringify(data);
      this.$post("/nozzle/web/member_education_save", {
        data: data,
      }).then((res) => {
        console.log(res);
        if (res.data.status == 1) {
          this.$message.success("操作成功");
          this.$emit("show", 1);
        }
      });
    },
  },
  mounted() {},
  computed: {},
};
</script>
<style lang="less" scoped>
/deep/.ant-input {
  height: 44px !important;
  border-radius: 10px;
  width: 100%;
}
// /deep/.ant-calendar-picker {
//   width: calc(50% - 30px);
// }
/deep/.ant-calendar-range-picker-separator {
  position: relative;
  top: 6px;
}
.content {
  background-color: #f1f5fc;
  padding: 20px 50px;
  margin-top: 5px;
  margin-bottom: 10px;
  .title {
    font-size: 15px;
  }
  .cont {
    padding-top: 20px;
    display: flex;
    flex-wrap: wrap;
    .baoguo {
      display: flex;
      width: 100%;
    }
    .box {
      width: calc(50% - 30px);
      margin-right: 60px;
      margin-bottom: 20px;
      .selectBox {
        margin-top: 10px;
        width: 100%;
        border-radius: 10px;
        border: 1px solid #d8d8d8;
        background-color: #fff;
        padding: 2px;
        padding-bottom: 0;
        box-sizing: border-box;
        display: flex;
        cursor: pointer;
        .contBox {
          width: calc(100% - 50px);
          display: flex;
          flex-wrap: wrap;
          .text {
            height: 38px;
            display: flex;
            align-items: center;
            padding-left: 15px;
            color: #9c9c9c;
            margin-bottom: 2px;
          }
          .hei {
            color: #000;
          }
          .li {
            background-color: #e2e4ec;
            border-radius: 10px;
            height: 38px;
            padding: 0 6px 0 10px;
            margin-right: 2px;
            margin-bottom: 2px;
            color: #000;
            .iconfont {
              position: relative;
              top: 1px;
              font-size: 14px;
              margin-left: 5px;
              cursor: pointer;
            }
          }
        }
        .barrage {
          width: 50px;
          font-size: 25px;
          cursor: pointer;
          color: #9c9c9c;
        }
      }
      .selectBox:hover {
        border: 1px solid #147ee0;
        .contBox {
          .text {
            color: #147ee0;
          }
        }
      }
      .inpBox {
        margin-top: 10px;
        width: 100%;
        border-radius: 10px;
        border: 1px solid #d8d8d8;
        background-color: #fff;
        padding: 2px;
        padding-bottom: 0;
        box-sizing: border-box;
        display: flex;
        cursor: pointer;
        input {
          height: 38px;
          padding: 0 15px;
          width: 100%;
          box-sizing: border-box;
        }
      }
      .inpBox:hover {
        border: 1px solid #147ee0;
      }
    }
    .box:nth-child(2n) {
      margin-right: 0;
    }
    .quanBox {
      width: calc(50% - 30px);
      margin-right: 0;
      margin-bottom: 20px;
      .xuanCont {
        display: flex;
        align-items: center;
        margin-top: 10px;
        .xuanBox {
          box-sizing: border-box;
          background-color: #fff;
          width: 150px;
          border-radius: 10px;
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
        .jian {
          margin: 0 12px;
          font-size: 18px;
        }
      }
      .areaBox {
        border: 1px solid #d8d8d8;
        height: 200px;
        background-color: #fff;
        border-radius: 10px;
        margin-top: 15px;
        overflow: hidden;
        padding: 15px;
        box-sizing: border-box;
        textarea {
          width: 100%;
          height: 100%;
          border: none;
        }
      }
    }
  }
  .tcBom {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    .btn {
      width: 90px;
      border-radius: 5px;
      height: 40px;
      background-color: #147ee0;
      color: #fff;
      cursor: pointer;
    }
    .qbtn {
      cursor: pointer;
      width: 90px;
      border-radius: 5px;
      height: 40px;
      box-sizing: border-box;
      border: 1px solid #147ee0;
      color: #147ee0;
      margin-right: 20px;
    }
  }
}
</style>
